<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--invoice-paid">
        <div class="edit-popup__header edit-popup__header-invoice-paid">
          <div class="edit-popup__title">
            <span>Status: Paid</span>
          </div>
          <div class="edit-popup__close" @click="closeModal">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <form>
          <div class="form-status">
            <div class="form-status__top">
              <div class="">
                <span>Amount Paid ({{getCurrencySign(invoice.currencyType)}})</span>
                <div class="form-control">{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(invoice.totalAmountPayable)}}</div>
              </div>
              <div class="">
                <span>Date of Payment</span>
                <div class="form-control-wrap" :class="{'is-error': validErrorCurrentDatePaid}">
                  <input
                      type="text"
                      placeholder="Date"
                      v-model="templateInvoicePaid.status.paidData.dateOfPayment"
                      @blur="convectorFormat($event.target.value)"
                      class="form-control js-datepicker-single" />
                  <div class="form-control-icon">
                    <svg
                        width="1em"
                        height="1em"
                        class="icon icon-calendar">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-status__body">
              <span class="title">Payment Method</span>
              <payment-method-select
                  v-model="templateInvoicePaid.status.paidData.paymentMethod"
                  :bank-id="invoice.bankId"
                  :disabled="!hasClientContract && !isAdmin"
                  :is-admin="isAdmin"
              />
            </div>
            <div class="form-status__btn">
              <div @click="upInvoiceStatusPaid" class="btn btn--green" :disabled="validErrorCurrentDatePaid">
                <span>Save</span>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>

import Vuex from "vuex";
import Lightpick from "lightpick";
import {actionTypes as actionTypesInvoice} from "@/store/modules/invoices";
import {format, parse} from "date-fns";
import {getCurrencySign} from '@/common/helpers/currency'
import PaymentMethodSelect from '@/components/invoices/PaymentMethodSelect.vue'

export default {
  name: 'AtModalInvoiceStatusPaid',
  components: {PaymentMethodSelect},
  props: {
    invoice: {
      type: Object,
      require: true
    },
    hasClientContract: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      now: Date.now(),
      dateOfPayment: '',
      amountPaid: 1,
      validErrorCurrentDatePaid: true,
      templateInvoicePaid: {
        status: {
          type: "",
          paidData: {
            amountPaid: 0,
            dateOfPayment: "",
            paymentMethod: ""
          },
        },
        userId: 0
      }
    }
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      updateInvoiceStatus: actionTypesInvoice.updateInvoiceStatus
    }),
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    upInvoiceStatusPaid(){
      const payload = {
        param: this.templateInvoicePaid,
        invoiceId: this.invoice.id
      }
        this.updateInvoiceStatus(payload).then(() => this.closeModal())
    },
    closeModal() {
      // console.log('closeModal')
      this.$emit('closeModalInvoiceStatusPaidOptions', false)
      this.templateInvoicePaid.status.type = ''
      this.templateInvoicePaid.status.paidData.amountPaid = 0
      this.templateInvoicePaid.status.paidData.dateOfPayment = ''
      this.templateInvoicePaid.status.paidData.paymentMethod = ''
      this.templateInvoicePaid.userId = null
    },
    convectorFormat(date) {
      this.templateInvoicePaid.status.paidData.dateOfPayment = date
      this.parseDate(date) > this.now ? this.validErrorCurrentDatePaid = true : this.validErrorCurrentDatePaid = false
    },
    parseDate(date) {
      if (!date) return
      return new Date(
          format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy, MM, dd')
      )
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
  },
  mounted() {
    this.updateDatePickers()
    this.templateInvoicePaid.status.type = this.invoice.status
    this.templateInvoicePaid.status.paidData.amountPaid = this.invoice.totalAmountPayable
    this.templateInvoicePaid.status.paidData.dateOfPayment = this.invoice.dateOfPayment
    this.templateInvoicePaid.status.paidData.paymentMethod = this.invoice.paymentMethod
    this.templateInvoicePaid.userId = this.invoice.userId
  }
}
</script>

<style lang="scss" scoped>
.edit-popup {
  padding: 20px 35px 35px 35px;
}
.edit-popup--invoice-paid {
  width: 350px;
  .edit-popup__header-invoice-paid {
    padding-bottom: 20px;
    .edit-popup__title {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;

      text-transform: capitalize;

      color: #2E2E2E;
    }
  }
  .form-status {
    .form-status__top {
      display: grid;
      grid-template-columns: 130px 130px;
      grid-column-gap: 20px;

      padding-bottom: 30px;

      .form-control {
        display: flex;
        align-items: center;
      }

      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;

        color: #1A1A1A;

        display: block;

        padding-bottom: 12px;
      }
    }
    .form-status__body {
      .title {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;

        color: #1A1A1A;

        display: block;

        padding-bottom: 12px;
      }
    }
    .form-status__btn {
      padding-top: 30px;

      display: flex;
      justify-content: center;
    }
  }
}
</style>
